module.exports = __webpack_public_path__ + "img/team-logo@3x.03dbb811.jpg";